import { FC } from 'react';
import { CheckoutConfirmationResponseType } from 'src/models/Checkout/Confirmation';
import { useTHelper } from 'src/utils/i18n';
import { CheckoutConfirmationTableLayout } from 'src/pages/Checkout/components/common/TableLayout';
import { UiOuterLink } from 'src/components/UI/OuterLink';

type Props = {
  model: CheckoutConfirmationResponseType['TicketingGroupTicketRegistrationsSubsection'];
};

export const CheckoutTicketingGroupTicketRegistrations: FC<Props> = ({ model }) => {
  const tHelper = useTHelper('checkout.confirmation.ticketingGroupTicketRegistrations');

  return (
    <>
      <h2 className="section-header">{model.SectionHeader}</h2>
      {model.Items.map((item, index) => (
        <CheckoutConfirmationTableLayout
          /* eslint-disable-next-line react/no-array-index-key */
          key={index}
          tHead={
            <tr>
              <th className="left">{item.FirstAndLastName}</th>
              <th className="right">{tHelper('information')}</th>
            </tr>
          }
        >
          <tr>
            <td className="left">{model.TicketGroupsTerminology.Singular}</td>
            <td className="right">{item.GroupTitle}</td>
          </tr>
          <tr>
            <td className="left">{tHelper('id', { terminology: model.TicketsTerminology.Singular || '' })}</td>
            <td className="right">{item.CampaignRegistrationId}</td>
          </tr>
          {item.GroupName && (
            <tr>
              <td className="left">{tHelper('name', { terminology: model.TicketGroupsTerminology.Singular || '' })}</td>
              <td className="right">{item.GroupName}</td>
            </tr>
          )}
          {item.CustomFields.map((field) => (
            <tr key={field.Name}>
              <td className="left">{field.Name}</td>
              <td className="right">{field.Value}</td>
            </tr>
          ))}
          {item.InvitationLink && (
            <tr>
              <td className="left">{tHelper('invitationLinkTitle')}</td>
              <td className="right">
                {item.InvitationLink && (
                  <UiOuterLink className="link-hoverable" href={item.InvitationLink}>
                    {item.InvitationLink}
                  </UiOuterLink>
                )}
              </td>
            </tr>
          )}
        </CheckoutConfirmationTableLayout>
      ))}
    </>
  );
};
